import { CircularProgress } from '@mui/joy';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useDelayedLoading } from '../hooks/useDelayedLoading';
import { Container, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { pictos } from '../assets/img/pictos';
import Chemin from '../components/Chemin';
import Navigation from '../components/Navigation';
import StandPlanSvg from '../components/StandPlanSvg';
import '../styles/plan.css';

const PlanStand = () => {
  const evenementSelected = useSelector(state => state.evenements.evenementSelect);
  const monProfil = useSelector(state => state.profil.profil);
  const plan = useSelector(state => state.evenements.planSelected);

  const [isLoading, setIsLoading] = useState(true);
  const showLoading = useDelayedLoading(isLoading, 250);
  const loadStartTime = useRef(performance.now());
  const navOpen = true;
  const param = useParams();
  const location = useLocation();

  const dispatch = useDispatch();

  // Handle plan load complete - measure total load time and hide spinner
  const handlePlanLoad = useCallback(() => {
    const loadTimeMs = Math.round(performance.now() - loadStartTime.current);
    console.info('[PlanStand] total load time:', loadTimeMs, 'ms');
    setIsLoading(false);
  }, []);

  //Breadcrumbs
  const breadCrumbs = useSelector(state => state.profil.chemin);

  const breadcrumbsTemp = useMemo(() => {
    const breadcrumbs_temp = breadCrumbs.filter(item => item.nom === 'Accueil');
    breadcrumbs_temp.push({ url: location.pathname, nom: 'Plan des stands' });
    return breadcrumbs_temp;
  }, [breadCrumbs, location.pathname]);

  useEffect(() => {
    const alreadySet =
      Array.isArray(breadCrumbs) &&
      breadCrumbs.some(item => item?.nom === 'Plan des stands' && item?.url === location.pathname);
    if (!alreadySet) {
      dispatch({
        type: 'Profil/addChemin',
        payload: breadcrumbsTemp,
      });
    }
  }, [breadCrumbs, breadcrumbsTemp, dispatch, location.pathname]);

  useEffect(() => {
    loadStartTime.current = performance.now();
    setIsLoading(true);
  }, [plan, param.idPartenaire]);

  useEffect(() => {
    if (!plan) {
      setIsLoading(false);
    }
  }, [plan]);

  const planDataUrl = useMemo(() => {
    if (!plan) return '';
    if (param.idPartenaire === '0') {
      const eventId = evenementSelected?.id;
      if (eventId) {
        const backendOrigin = new URL(plan).origin;
        return `${backendOrigin}/api/evenement/${eventId}/plan-preview/data`;
      }
      return `${plan}/data`;
    }
    return `${plan}/${param.idPartenaire}/data`;
  }, [plan, param.idPartenaire, evenementSelected?.id]);

  return (
    <Container fluid className="d-flex flex-column" style={{ height: '100vh', overflow: 'hidden' }}>
      <Row className="flex-shrink-0">
        <Navigation
          button={true}
          titre={'Plan des stands'}
          icone={pictos.plan_stand_rond_icone}
          evenement={evenementSelected.photo}
          photo={monProfil.photo_path}
          retour="dashboard"
          selected={6}
          open={navOpen.toString()}
          menus={true}
        />
      </Row>

      <Row className="p-0 flex-shrink-0">
        <Chemin breadCrumbs={breadcrumbsTemp} />
      </Row>

      <Row
        className="flex-grow-1 d-flex justify-content-center align-items-center"
        style={{ minHeight: 0, position: 'relative' }}
      >
        {showLoading && (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ position: 'absolute', zIndex: 5 }}
          >
            <CircularProgress />
          </div>
        )}
        {!plan ? (
          <div className="d-flex justify-content-center align-items-center">No plan available.</div>
        ) : (
          <div className="iframe-carte" style={{ width: '100%', height: '100%' }}>
            <StandPlanSvg dataUrl={planDataUrl} onLoaded={handlePlanLoad} />
          </div>
        )}
      </Row>
    </Container>
  );
};

export default PlanStand;
